import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../../environments/environment';

@Injectable()
export class PostulacionesSaludService
{
    constructor(private http: HttpClient) { }

    sinPostulacionesVigentes(idProducto: any, rut: any, titular: any)
    {
        return this.http.get(`${environment.urlBase}/postulacion`,
               { headers: this.armaCabecera(), params: { idProducto: idProducto, rut: rut, titular:titular } } ).toPromise();
    }

    traeRegiones()
    {
        return this.http.get(`${environment.urlApiSolicitudes}/regiones`,
        { headers:this.armaCabecera() }).toPromise();
    }

    traeEstados()
    {
        return this.http.get(`${environment.urlApiSolicitudes}/postulaciones/estados`,
        { headers:this.armaCabecera() }).toPromise();
    }

    traeUsuario(rut: any)
    {
        return this.http.get(`${environment.urlApiSolicitudes}/afiliados/rut/${rut}`,
        { headers:this.armaCabecera() }).toPromise();
    }

    traeTipoProductoSalud(idEjecutivo: any)
    {
        return this.http.get(`${environment.urlApiSolicitudes}/postulaciones/tipoProductosSalud/idUsuario/${idEjecutivo}`,
        { headers:this.armaCabecera() }).toPromise();
    }
    
    traeTipoCategoriasSalud(idProducto: any)
    {                                                           
        return this.http.get(`${environment.urlApiSolicitudes}/postulaciones/tipoCategoriasSalud/producto/${idProducto}`,
        { headers:this.armaCabecera() }).toPromise();
    }

    cambiarEstadoPostulacion(idPostulacion: any, estado: any, idUsuarioSesion: any)
    {
      
        return this.http.post(`${environment.urlApiOperacion}/solicitudes/`,
               { id: idPostulacion, estado: estado, idUsuarioSesion:idUsuarioSesion }, { headers:this.armaCabecera() } ).toPromise();
    }

    envioCompania(idPostulacion: any)
    {
        console.log("BCI");
        console.log(idPostulacion)
        return this.http.post(`${environment.urlApiOperacion}/solicitudes/cambiarEstadoPostulacion/idPostulacion/${idPostulacion}`,
                { headers:this.armaCabecera() } ).toPromise();
    }

    envioCompaniaVidaCamara(idPostulacion: any)
    {   
        console.log("VIDA CAMaRA");
        console.log(idPostulacion)
        return this.http.post(`${environment.urlApiOperacion}/solicitudes/cambiarEstadoPostulacionNuevaIntegracion/idPostulacion/${idPostulacion}`,
                { headers:this.armaCabecera() } ).toPromise();
    }

    traePostulacionesDisponibles(email: any, buscador?: any)
    {
        return this.http.post(`${environment.urlApiSolicitudes}/postulaciones/reembolso-salud/ejecutivo/email`,
        {
            email: email,
            fechaInicial: buscador?.fechaInicio?.split('-')?.reverse()?.join('-'),
            fechaFinal: buscador?.fechaFin?.split('-')?.reverse()?.join('-'),
            filtroIngresado: false,
            numeroPagina:buscador?.currentPage,
            tamanioPagina: buscador?.itemsPerPage,
            idRegion:buscador?.region,
            rut: buscador?.rut,
            idSolicitud: buscador?.idSolicitud,
            estado: buscador?.estado,
            tipoProducto: buscador?.tipoProductoselect,
            tipoCategoria: buscador?.tipoCategoriaselect
        },
        { headers:this.armaCabecera() }).toPromise()
    }

	traePostulacionesAfiliado(email: any, buscador?: any)
    {
        return this.http.post(`${environment.urlApiSolicitudes}/postulaciones/reembolso-salud/afiliados/email`,
        {
            email: email,
            fechaInicial: buscador?.fechaInicio?.split('-')?.reverse()?.join('-'),
            fechaFinal: buscador?.fechaFin?.split('-')?.reverse()?.join('-'),
            filtroIngresado: false,
            numeroPagina:buscador?.currentPage,
            tamanioPagina: buscador?.itemsPerPage,
            idRegion:buscador?.region,
            rut: buscador?.rut,
            idSolicitud: buscador?.idSolicitud,
            estado: buscador?.estado
        },
        { headers:this.armaCabecera() }).toPromise()
    }

    traePostulacionesAsignadas(idEjecutivo: any, buscador?: any)
    {
        return this.http.post(`${environment.urlApiSolicitudes}/postulaciones/reembolso-salud/ejecutivos/id/`,
        {
            id:idEjecutivo,
            numeroPagina: buscador?.currentPage,
            tamanioPagina: buscador?.itemsPerPage,
            idSolicitud: buscador?.idSolicitud,
            rut: buscador?.rut,
            fechaInicial: buscador?.fechaInicio?.split('-')?.reverse()?.join('-'),
            fechaFinal: buscador?.fechaFin?.split('-')?.reverse()?.join('-'),
            estado: buscador?.estado,
            idRegion:buscador?.region,
            tipoProducto: buscador?.tipoProductoselect,
            tipoCategoria: buscador?.tipoCategoriaselect
        },
        { headers:this.armaCabecera() }).toPromise()
    }

    asignaPostulacion(postulaciones: any, idEjecutivo: any)
    {
       
        return this.http.post(`${environment.urlApiOperacion}/solicitudes/asignar/ejecutivo/${idEjecutivo}`,
        postulaciones, { headers:this.armaCabecera() } ).toPromise()
    }

    traePostulacionReembolso(idPostulacion: any,montoCalculado: any)
    { 
        return this.http.get(`${environment.urlApiSolicitudes}/postulaciones/${idPostulacion}/reembolsos/${montoCalculado}`,
               { headers:this.armaCabecera() }).toPromise()
    }


    traePostulacionAyudaMedica(idPostulacion: any)
    { 
        return this.http.get(`${environment.urlApiAyudaMedica}/postulaciones/ayudamedica/${idPostulacion}`,
               { headers:this.armaCabecera() }).toPromise()
    }

    editaPostulacionReembolso(idPostulacion: any, idCarga: any, reembolso: any,idUsuario: any)
    {
     if(idCarga!=null){
        idCarga=idCarga.id;
      }else{
        idUsuario=idUsuario.id;
      }
      let idUsuarioSesion = localStorage.getItem("idUsuario")
        return  this.http.put(`${environment.urlApiOperacion}/solicitudes/`,
                {

                    id: idPostulacion,
                    idCarga: idCarga,
                    idUsuario: idUsuario,
                    idUsuarioSesion: idUsuarioSesion,
                    idProducto: 3,
                    archivoAdjunto:reembolso.archivo,
                    reembolso:
                    {
                        idTipo: reembolso.tipoReembolso,
                        idReembolsoCat: reembolso.categoria,
                        idReembolsoSubcat: reembolso.subcategoria,
                        observacion:reembolso.observacion,
                        idPrevision: reembolso.prevision,
                        numDocumento: reembolso.nDocumento,
                        numBoleta: reembolso.nBoleta,
                        rutPrestador: reembolso.rutPrestador.split('-')[0],
                        dvPrestador: reembolso.rutPrestador.split('-')[1],
                        montoCopago: reembolso.montoCopago,
                        montoReembolso: reembolso.montoReembolso,
                        tipoDocumento: reembolso.tipoDocumento,
                        fechaDocumento: reembolso.fechaDocumento
                    }
                },
                { headers:this.armaCabecera() } ).toPromise()
    }

    motivoRechazo(idProducto: any)
    {
        return this.http.get(`${environment.urlApiSolicitudes}/motivoRechazo/productos/${idProducto}/`,
               { headers:this.armaCabecera() }).toPromise()
    }

    traeArchivos(idPostulacion: any)
    {   
        return this.http.get(`${environment.urlApiSolicitudes}/postulaciones/${idPostulacion}/archivo-adjunto/`,
               { headers:this.armaCabecera() }).toPromise()
    }

    armaCabecera()
    {
        return new HttpHeaders({
            'Content-Type':'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem("jwt"),
            'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE',
            'Access-Control-Allow-Origin': '*',
        });
    }
}
